import { isNil } from '@tunein/web-utils';
import retry from 'async-retry';
import axios from 'axios';
import defaultsDeep from 'lodash/defaultsDeep';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import omitBy from 'lodash/omitBy';
import pick from 'lodash/pick';
import ApiError from './errors/ApiError';
import { camelCase } from './transforms';
const axiosParams = ['method', 'url', 'data', 'auth'];
export default function tuneInRequest(requestConfig, apiContext) {
    if (isEmpty(requestConfig.url)) {
        throw new Error('api endpoint must be configured and defined.');
    }
    const startTime = Date.now();
    const axiosRequest = pick(requestConfig, axiosParams);
    function responseHandler(res) {
        const responseTime = Date.now() - startTime;
        const responseParams = {
            responseTime: responseTime,
            status: res ? res.status : null,
        };
        const configParams = pick(axiosRequest, ['url', 'method']);
        if (apiContext.logCookieNames && axiosRequest.headers.cookie) {
            configParams.cookieNames = axiosRequest.headers.cookie
                .split('; ')
                .map((cookie) => cookie.includes('=') && cookie.split('=')[0])
                .filter((val) => val)
                .join(',');
        }
        const trackingData = merge({}, responseParams, configParams);
        apiContext.track(trackingData);
    }
    axiosRequest.withCredentials = true;
    if (!requestConfig.withoutParams) {
        axiosRequest.params = omitBy(defaultsDeep(requestConfig.params, apiContext.params), isNil);
        if (requestConfig.url.startsWith(apiContext.domains.opml)) {
            axiosRequest.params.render = 'json';
        }
    }
    axiosRequest.headers = defaultsDeep(requestConfig.headers, apiContext.headers);
    axiosRequest.transformResponse = [].concat(axios.defaults.transformResponse);
    axiosRequest.timeout = apiContext.timeout;
    axiosRequest.httpsAgent = apiContext.apiHttpsAgent;
    if (!requestConfig.disableCamelCase) {
        axiosRequest.transformResponse.push(camelCase);
    }
    if (requestConfig.transformResponse) {
        axiosRequest.transformResponse.push(requestConfig.transformResponse);
    }
    if (requestConfig.isAjax) {
        axiosRequest.headers['X-Requested-With'] = 'XMLHttpRequest';
    }
    if (requestConfig.noAuthHeader) {
        delete axiosRequest.headers.Authorization;
    }
    const requestCallback = (bail, reqAttempt) => axios({
        ...axiosRequest,
        params: {
            ...axiosRequest.params,
            reqAttempt,
        },
    })
        .then((res) => {
        responseHandler(res);
        return res;
    })
        .catch((err) => {
        responseHandler(err.response);
        throw err;
    })
        .catch((err) => {
        const errorToUse = axios.isAxiosError(err) ? new ApiError(err) : err;
        if (err.code !== 'ECONNABORTED') {
            return bail(errorToUse);
        }
        throw errorToUse;
    });
    return retry(requestCallback, {
        retries: requestConfig.disableRetry
            ? 0
            : requestConfig.retries || apiContext.retryLimit || 0,
    });
}
